export const LinksConfig = {
    linkedin: "https://www.linkedin.com/in/hanne-heing%C3%A5rd-698a2b141/",
    github: "https://github.com/hanneheingard",
    resume: "https://www.facebook.com",
    // Add more links as needed
};